import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { LoanConsultantsDocument, type LoanConsultantsQuery } from 'graphql/generated/graphql';

const useGetLoanConsultants = (): [LoanConsultantsQuery['loanConsultants'], boolean] => {
  const { data, loading } = useQuery(LoanConsultantsDocument);
  const noLoanConsultants: LoanConsultantsQuery['loanConsultants'] = [];
  const loanConsultants = get(data, 'loanConsultants', noLoanConsultants);
  return [loanConsultants, loading];
};

export default useGetLoanConsultants;
